import DATA_STATES from '@emmacare/common/data/states.json'

import addAllValue from 'src/utils/functions/addAllValue'

export const COMMON_GET_BILLING_PROGRAMS = '/workflow/billing/programs'
export const COMMON_GET_FACILITIES = '/company/facility'
export const COMMON_GET_CASE_MANAGERS = '/company/case-managers'
export const COMMON_GET_CLINICIANS = '/company/clinician'
export const COMMON_GET_CAREGIVERS = '/company/careGiver'
export const COMMON_GET_AGENCY_CASE_MANAGERS = '/company/agencyCaseManager'
export const COMMON_SOURCE_GET_LIST = '/company/referralSource'
export const COMMON_EPROMS_LIST = '/workflow/clinical-pathway'

export const INTERVENTIONS_LIST_BY_GOAL_GET =
  '/workflow/intervention/goal/:goalUuid'
export const INTERVENTIONS_LIST_GET = '/workflow/intervention'
export const GOALS_LIST_GET = '/workflow/goal'
export const REFERRAL_PAYERS_LIST_GET = '/company/referralPayer'

export const ACTION_HUB_GET_COUNTER = '/company/tasks/assigned'
export const ACTION_HUB_PATCH_ATTACHMENTS =
  '/company/task/:taskUuid/attachments'
export const ACTION_HUB_MODAL_ASSIGNEE_LIST_GET = '/company/tasks/assigneeList'

export const DEFAULT_SORT = {
  sortedColumn: '',
  sortedColumnOrder: 'descend'
}

export const DEFAULT_PAGINATION: any = {
  position: ['topRight', 'bottomRight'],
  showSizeChanger: false,
  size: 'small',
  total: 0,
  current: 1,
  pageSize: 50,
  defaultCurrent: 1,
  showTotal: (total: number, range: number[]) =>
    `${range[0]}-${range[1]} of ${total}`
}

export const statusesByName = new Map([
  ['Pending', 1],
  ['Pre-Active', 2],
  ['Active', 3],
  ['On Hold', 4],
  ['Discharged', 5]
])

export const PRIORITY: Map<number, any> = new Map([
  [
    0,
    {
      className: 'priority priority_none',
      title: '-',
      value: 0
    }
  ],
  [
    1,
    {
      className: 'priority priority_low',
      title: 'Low',
      value: 1
    }
  ],
  [
    2,
    {
      className: 'priority priority_medium',
      title: 'Medium',
      value: 2
    }
  ],
  [
    3,
    {
      className: 'priority priority_high',
      title: 'High',
      value: 3
    }
  ]
])

export const ENROLLED_PROGRAMM_STATUSES_BY_NUMBERS: Map<number, any> = new Map([
  [
    0,
    {
      className: 'status',
      title: '-',
      value: 0
    }
  ],
  [
    1,
    {
      className: 'status status_pending',
      title: 'Pending',
      value: 1
    }
  ],
  [
    2,
    {
      className: 'status status_pre-active',
      title: 'Pre-Active',
      value: 2
    }
  ],
  [
    3,
    {
      className: 'status status_active',
      title: 'Active',
      value: 3
    }
  ],
  [
    4,
    {
      className: 'status status_on-hold',
      title: 'On Hold',
      value: 4
    }
  ],
  [
    5,
    {
      className: 'status status_discharged',
      title: 'Discharged',
      value: 5
    }
  ]
])

export const PATIENT_STATUSES_DROPDOWN = Array.from(
  ENROLLED_PROGRAMM_STATUSES_BY_NUMBERS
)
  .map(([key, { title, value }]) => ({ key, label: title, title, value }))
  .filter(
    ({ value }) => ENROLLED_PROGRAMM_STATUSES_BY_NUMBERS.get(0)?.value !== value
  )

export const PATIENT_STATUSES_DROPDOWN_WITH_ALL = addAllValue(
  PATIENT_STATUSES_DROPDOWN
)

export const PROGRAM_VALUES = [
  {
    title: 'CCM',
    label: 'CCM',
    value: 'ccm'
  },
  {
    title: 'CoCM',
    label: 'CoCM',
    value: 'cocm'
  },
  {
    title: 'RPM',
    label: 'RPM',
    value: 'rpm'
  },
  {
    title: 'RTM',
    label: 'RTM',
    value: 'rtm'
  },
  {
    title: 'BHI',
    label: 'BHI',
    value: 'bhi'
  },
  {
    title: 'APCM',
    label: 'APCM',
    value: 'apcm'
  }
]

export const PROGRAM_VALUES_WITH_NONE = [
  ...PROGRAM_VALUES,
  {
    title: 'None',
    label: 'None',
    value: 'none'
  }
]

export const PROGRAM_VALUES_WITH_ALL_V5 = addAllValue(
  PROGRAM_VALUES_WITH_NONE,
  false,
  'All',
  ''
)

export const STATUSES_BY_NUMBERS: Map<number, any> = new Map([
  [
    0,
    {
      className: 'status',
      title: '-',
      value: 0
    }
  ],
  [
    1,
    {
      className: 'status status_new',
      title: 'New',
      value: 1
    }
  ],
  [
    2,
    {
      className: 'status status_in-progress',
      title: 'In progress',
      value: 2
    }
  ],
  [
    3,
    {
      className: 'status status_closed',
      title: 'Closed',
      value: 3
    }
  ],
  [
    4,
    {
      className: 'status status_on-hold',
      title: 'On Hold',
      value: 4
    }
  ],
  [
    5,
    {
      className: 'status status_discontinued',
      title: 'Discontinued',
      value: 5
    }
  ],
  [
    10,
    {
      className: 'status status_completed',
      title: 'Completed',
      value: 10
    }
  ]
])

export const ROW_CLASS_NAME_BY_PRIORITY: Map<number, string> = new Map([
  [1, 'row_priority-low'],
  [2, 'row_priority-medium'],
  [3, 'row_priority-high']
])

export const BILLING_OPTIONS = [
  {
    title: 'All',
    value: null
  },
  {
    title: 'Only Billable (CCM, RPM, RTM)',
    value: 'onlyBillable'
  },
  {
    title: 'Only CCM',
    value: 'ccmType'
  },
  {
    title: 'Only RPM',
    value: 'rpmType'
  },
  {
    title: 'Only RTM',
    value: 'rtmType'
  }
]

export const TOP_MENU = [
  {
    key: 'patients',
    link: '/',
    title: 'Patients'
  },
  {
    key: 'activities',
    link: '/activities',
    title: 'Activities'
  }
]

export const LANDING_ADRESS = 'https://emmacare.com'
export const GOOGLE_APP_ADRESS = 'http://bit.ly/2STy5nX'
export const APPLE_APP_ADRESS = 'https://apple.co/39ZTeCH'

export const AVAILABLE_UPLOAD_FILE_EXTENSIONS = {
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx'
  ],
  'application/vnd.oasis.opendocument.spreadsheet': ['.ods'],
  'application/vnd.oasis.opendocument.text': ['.odt'],
  'application/pdf': ['.pdf'],
  'application/rtf': ['.rtf'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx'
  ],
  'image/gif': ['.gif'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
  'image/tiff': ['.tif', '.tiff'],
  'text/csv': ['.csv'],
  'text/plain': ['.txt']
}

export const AVAILABLE_UPLOAD_FILE_EXTENSIONS_ANTD =
  '.tiff, .gif, .jpeg, .jpg, .png, .rtf, .ods, .odt, .pdf, .xls, .xlsx, .doc, .docx, .csv, .txt, .dot, .xlt'

export const USER_TYPE_PROVIDER_USER = 'provider_user'

export const WEBSOCKET_EVENT_TASK_COUNT = '59'

export const DATA_STATES_DROPDOWN = DATA_STATES.map((el) => ({
  ...el,
  key: el.name,
  value: el.abbreviation,
  label: el.name,
  title: el.name
}))

export const ALL_VALUE = { key: 0, title: 'All', value: 0 }

export const ALL_ITEM = {
  key: 'all',
  title: 'All',
  label: 'All',
  value: '',
  children: []
}

export const NO_REFERALPAYER_DROPDOWN_VALUE = {
  key: 'no-referral-payer',
  label: 'No referral payer',
  title: 'No referral payer',
  value: 'no-referral-payer'
}

export const NO_INSURANCE_DROPDOWN_VALUE = {
  key: 'no-insurance',
  title: 'No insurance',
  value: 'no-insurance'
}

export const NO_REFERRAL_REASON = {
  key: 'no-referral-reason',
  title: 'No referral reason',
  value: 'no-referral-reason'
}

export const NO_ENROLLMENTSPECIALIST_DROPDOWN_VALUE = {
  key: 'no-enrollment-specialist',
  title: 'No enrollment specialist',
  value: 'no-enrollment-specialist'
}

export const NO_REFERRAL_SUBGROUP_VALUE = {
  key: 'no-referral-source-sub-group',
  title: 'No referral sub-group',
  label: 'No referral sub-group',
  value: 'no-referral-source-sub-group'
}

export const NO_REFSOURCE_DROPDOWN_VALUE = {
  key: 'no-referral-source',
  label: 'No referral provider',
  title: 'No referral provider',
  value: 'no-referral-source'
}

export const NO_CLINICIAN_DROPDOWN_VALUE = {
  key: 'no-clinician',
  label: 'No clinician',
  title: 'No clinician',
  value: 'no-clinician'
}

export const PATIENT_STATUS_FILTER_V5 = Array.from(statusesByName)
  .map(([title, value]) => ({ title, value, label: title }))
  .sort((a, b) => {
    if (a.title < b.title) {
      return -1
    } else if (a.title > b.title) {
      return 1
    }

    return 0
  })

export const PATIENT_STATUS_FILTER_WITH_ALL_V5 = addAllValue(
  PATIENT_STATUS_FILTER_V5.filter(
    ({ title }) => !['Pending', 'Inactive'].includes(title)
  ),
  true,
  'All',
  ''
)
